onComplete(function () {
	// Add code here.
	document.querySelectorAll('.blog-overview').forEach(el => {
		el.classList.add('blog-template-basic');
	});
});